import { SnackbarProvider } from 'notistack'

import { useLocation } from 'react-router-dom'

import { LocalizationProvider } from '@mui/x-date-pickers'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

import type { ChildrenType } from '@core/types'
import AuthProvider from '@/providers/AuthProvider'

// Routes that should bypass authentication
const PUBLIC_ROUTES = ['/setup']

// Wrap your client side provider here
export default function ClientProvider({ children }: ChildrenType) {
  const { pathname } = useLocation()
  const isPublicRoute = PUBLIC_ROUTES.some(route => pathname.startsWith(route))

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {isPublicRoute ? (
          <SnackbarProvider
            autoHideDuration={2000}
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top'
            }}
          >
            {children}
          </SnackbarProvider>
        ) : (
          <AuthProvider>
            <SnackbarProvider
              autoHideDuration={2000}
              anchorOrigin={{
                horizontal: 'center',
                vertical: 'top'
              }}
            >
              {children}
            </SnackbarProvider>
          </AuthProvider>
        )}
      </LocalizationProvider>
    </>
  )
}
